import styled, { keyframes } from 'styled-components';

export const TabWrapper = styled.div`
  position: absolute;
  width: 100%;
`;

export const TopPanelWrapper = styled.div`
  margin-bottom: 5px;
  background-color: #fff;
  position: relative;
  width: 100%;
`;

export const SummaryWrapper = styled.div`
  float: right;
  padding: 10px;
  display: flex;
  margin: 45px 10px 20px 20px;
`;

export const StyledNewFilterWrapper = styled.div`
  display: flex;
  float: left;
  margin: 45px 10px 20px 20px;
`;

export const WrapHeaderTitle = styled.h3<{ $borderColor?: string }>`
  margin: 0;
  padding: 0 6px 0 16px;
  position: relative;
  display: inline-block;
  max-width: 230px;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 700;
  color: #333;
  background-color: #f6f6f6;
  border: 1px solid #f6f6f6;
  cursor: pointer;

  ::before {
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 10px;
    background: ${(props) => props.$borderColor};
  }

  &:hover {
    border: 1px solid ${(props) => props.$borderColor};
  }
`;

export const WrapHeaderTitleIcon = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  background-color: #f6f6f6;
`;

export const Delimiter = styled.span`
  color: #215bff;
  padding: 0 0.25rem;
`;

export const StyledFilterWrapper = styled.div`
  position: absolute;
  top: 85px;
  left: ${(props) => props.position.left - 10 || 0}px;
  border: 1px solid #e8e8e8;
  background-color: #fff;
  padding: 1rem;
  box-shadow: 0 2px 3px 0 rgb(0 0 0 / 30%);
  border-radius: 3px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  max-width: 800px;

  & .ant-tabs-tab {
    margin: 0 5px 5px 0 !important;
  }

  & .ant-checkbox-inner::after {
    border-color: #1890ff !important;
  }

  & .ant-select-selection {
    max-height: 85px;
    overflow: auto;
  }

  & .ant-tabs-extra-content a {
    color: #1890ff !important;
  }
`;

export const ModalMask = styled.div`
  position: fixed;
  inset: 0;
  opacity: 0.6;
  z-index: 70;
  background-color: #d9d9d9;

  & + * {
    z-index: 71;
  }
`;

export const StyledCloseFilter = styled.div`
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s,
    opacity 0.5s linear;
  display: flex;
  justify-content: center;
  cursor: pointer;
  background-color: #ececec;
  width: 20px;
  align-items: center;
  font-weight: 700;
`;

export const StyledScopeWrapper = styled.div`
  display: flex;
  float: left;
  margin: 45px 10px 20px 20px;
  background-color: #ececec;
  &:hover ${StyledCloseFilter} {
    visibility: visible;
    opacity: 1;
  }
`;

export const LiveModeMarker = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
  margin-right: 5px;
`;

export const StyledDatePickerWrapper = styled.div`
  background-color: #ececec;

  div[class^='display'] {
    background-color: #ececec;
    border: none;
  }

  div[class^='live'] {
    background-color: #ececec;
    display: flex;
    align-items: center;
    border: none;

    i {
      margin-left: 3px;
      margin-top: 3px;

      svg {
        width: 0.4em;
        height: 0.4em;
      }
    }
  }

  #date-picker-live {
    display: flex;
    align-items: baseline;

    i {
      margin-left: 3px;

      svg {
        width: 0.4em;
        height: 0.4em;
      }
    }
  }

  div[class^='intervals'] {
    padding-top: 2px;
  }
`;

const blink = keyframes`
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
`;

export const TimeTablet = styled.div`
  padding: 6px 10px;
  min-width: 200px;
  text-align: left;
  color: #666;
  border-radius: 5px;
  font-size: 16px;
  float: right;
  background-color: #ececec;

  .live-text {
    color: #c00;
  }

  & .loading-time span {
    animation-name: ${blink};
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
`;
export const MarginLayout = styled.div`
  margin-right: 12.5px !important;
  margin-left: 7.5px !important;
`;
